import * as d3 from "d3";

/** Room for y-axis ticks + live price/time badge (matches candlestick live marker). */
export const RIGHT_LABEL_GUTTER = 78;
export const CHART_MARGIN = { top: 6, right: 2, bottom: 20, left: 4 };
// Matches candlestick / orderflow x-axis band (XSCALE_HEIGHT + padding).
export const TOP_TIME_AXIS_HEIGHT = 40;
export const AXIS_LABEL_DATE_Y = 11;
export const AXIS_LABEL_TIME_Y = 25;
export const AXIS_TICK_LINE_TOP = TOP_TIME_AXIS_HEIGHT - 8;
export const AXIS_TICK_LINE_BOTTOM = TOP_TIME_AXIS_HEIGHT - 2;
export const VT_PRIMARY_BLUE = "#315ED8";
export const CHART_BACKGROUND = "#022D5A";
export const AXIS_COLOR = "#ffffff";
export const RANGE_FILL = "rgba(49, 94, 216, 0.22)";
export const DAY_BOUNDARY_COLOR = "rgba(255,255,255,0.35)";
/** Fewest bars allowed across the viewport at max horizontal zoom-in. */
export const MIN_VISIBLE_CANDLES = 8;
/** Slight margin around the latest session day on first load / reset. */
export const INITIAL_SESSION_VIEW_PADDING = 1.12;
/** Cap default X zoom so we do not over-magnify on load. */
export const INITIAL_SESSION_VIEW_MAX_K = 2.5;
export const MAX_CANDLE_WIDTH = 48;
export const CANDLE_FILL_RATIO = 0.8;
export const ZOOM_WHEEL_STEP = 1.04;
export const ZOOM_IN_FACTOR = ZOOM_WHEEL_STEP;
export const ZOOM_OUT_FACTOR = 1 / ZOOM_WHEEL_STEP;
export const TICK_MINUTES = [1, 5, 10, 15, 30, 60, 120, 180, 240, 360, 480];
export const TICK_LABEL_CHAR_PX = 6.5;
export const MIN_TICK_LABEL_GAP_PX = 12;
export const AXIS_TICK_STEP_MIN_GAP_PX = 72;
export const X_ZOOM_IN_FACTOR = ZOOM_WHEEL_STEP;
export const X_ZOOM_OUT_FACTOR = 1 / ZOOM_WHEEL_STEP;
export const Y_ZOOM_IN_FACTOR = 1 / ZOOM_WHEEL_STEP;
export const Y_ZOOM_OUT_FACTOR = ZOOM_WHEEL_STEP;
// Match futspotopt / volx D3 charts (future_line_chart_container_new.js).
export const ZOOM_OUT_EXTREME = 0.3;
export const XSCALE_MAX_ZOOM = 1.9;
export const YSCALE_MAX_ZOOM = 1.9;
/** Smaller k = more vertical zoom-in (rescaleY). */
export const Y_ZOOM_MIN_K = 1 / YSCALE_MAX_ZOOM;
/** Larger k = more vertical zoom-out. */
export const Y_ZOOM_MAX_K = 1 / ZOOM_OUT_EXTREME;
export const IV_COLOR = "#caf4e7";              // was USD_COLOR
export const IV_NEXT_COLOR = "#cfa8e7";              // was LSD_COLOR
export const SD_UPPER_COLOR = "#ff6b6b"; // was IV_COLOR
export const SD_LOWER_COLOR = "#51cf66";              // was IV1_COLOR
export const DISABLED_LEGEND_COLOR = "#5b6b8c";
// export const IV_COLOR = "#caf4e7";
// export const IV1_COLOR = "#a8e7e1";
// export const USD_COLOR = "#ff6b6b";
// export const LSD_COLOR = "#51cf66";
export const IV_CURVE = d3.curveLinear;
export const MIN_CHART_WIDTH = 900;
export const MIN_CHART_HEIGHT = 520;
export const BOTTOM_PANEL_HEIGHT_RATIO = 0.24;
export const MIN_BOTTOM_PANEL_HEIGHT = 90;
export const BOTTOM_PANEL_GAP = 6;
export const BOTTOM_PANEL_BACKGROUND = "#03214A";
export const BOTTOM_PANEL_BORDER_COLOR = "#163569";

export const WHEEL_SENSITIVITY = 0.0006; 
export const PAN_DRAG_SPEED = 0.7; // 1 = follows cursor exactly, 0.5 = half speed
export const PAN_KEY_SPEED = 0.7;  // scales the arrow-key step


export const IV_RANGE_BOTTOM_HEIGHT_DEFAULT = Math.round(
    BOTTOM_PANEL_HEIGHT_RATIO * 100,
);

export const SD_BAND_FILL = "rgba(219, 231, 239, 0.12)";
export const selectSx = {
    height: 24,
    minWidth: 118,
    fontSize: 11,
    color: "#fff",
    backgroundColor: "#2f5cdb",
    borderRadius: "4px",
    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
    "& .MuiSvgIcon-root": { color: "#fff" },
    "& .MuiSelect-select": { py: 0.25 },
};

export const IV_RANGE_LINE_CONFIG = {
    iv: {
        field: "iv",
        label: "IV",
        color: IV_COLOR,
        scale: "iv",
        panel: "bottom",
        dash: [],
        defaultVisible: true,
    },
    iv1: {
        field: "iv1",
        label: "IV Next",
        color: IV_NEXT_COLOR,
        scale: "iv",
        panel: "bottom",
        dash: [4, 4],
        defaultVisible: true,
    },
    usd: {
        field: "usd",
        label: "+SD1",
        color: SD_UPPER_COLOR,
        panel: "main",
        dash: [],
        defaultVisible: true,
    },
    lsd: {
        field: "lsd",
        label: "-SD1",
        color: SD_LOWER_COLOR,
        panel: "main",
        dash: [],
        defaultVisible: true,
    },
    usd1: {
        field: "usd1",
        label: "Next +SD1",
        color: SD_UPPER_COLOR,
        panel: "main",
        dash: [4, 4],
        defaultVisible: false,
    },
    lsd1: {
        field: "lsd1",
        label: "Next -SD1",
        color: SD_LOWER_COLOR,
        panel: "main",
        dash: [4, 4],
        defaultVisible: false,
    },
};

export const IV_RANGE_LINE_KEYS = Object.keys(IV_RANGE_LINE_CONFIG);
export const MAIN_PANEL_LINE_KEYS = IV_RANGE_LINE_KEYS.filter(
    (key) => IV_RANGE_LINE_CONFIG[key].panel === "main",
);
export const BOTTOM_PANEL_LINE_KEYS = IV_RANGE_LINE_KEYS.filter(
    (key) => IV_RANGE_LINE_CONFIG[key].panel === "bottom",
);

export const EMPTY_API_PAYLOAD = { dateList: [], cc_data: [] };
